





























import ButtonCount from "@/common/components/atoms/ButtonCount.vue";
import InputNumber from "@/common/components/atoms/InputNumber.vue";
import { Prop, Component, Vue, Ref } from "vue-property-decorator";

@Component({
  components: {
    ButtonCount,
    InputNumber
  }
})
export default class FormCount extends Vue {
  @Prop({ type: String, required: false }) props!: string;
  @Prop({ type: String, required: true }) name!: string;
  @Prop({ type: Number, required: false, default: 0 }) value!: number;
  @Prop({ type: Number, required: false, default: 0 }) min!: number;
  @Prop({ type: Number, required: false, default: 9999 }) max!: number;
  @Prop({ type: Number, required: true, default: 0 }) stock!: any;
  @Prop({ type: [String, Number], required: true, default: 0 }) id!: any;

  @Ref("input") input!: any;

  get minusButtonDisabled() {
    return this.count <= this.min;
  }
  get plusButtonDisabled() {
    return this.count >= this.max || this.stock == 0;
  }

  get count() {
    return this.value;
  }
  set count(value) {
    this.$emit("input", value);
  }

  changeCount(value: any) {
    let newCount = parseInt(this.count.toString(), 10);
    newCount += value;
    if (newCount < this.min) newCount = this.min;
    if (newCount > this.max) newCount = this.max;
    this.input.changeCount(newCount);
  }
}
